import { action, payload } from 'ts-action'
import { ILoadingAction } from 'models/Loading'

export type TLoadingActions =
  | ReturnType<typeof SetFavoriteLoading>
  | ReturnType<typeof SetNotificationPreferenceLoading>

export const SetFavoriteLoading = action(
  'SetFavoriteLoading',
  payload<ILoadingAction>(),
)

export const SetNotificationPreferenceLoading = action(
  'SetNotificationPreferenceLoading',
  payload<ILoadingAction>(),
)
